// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2mVaq","icon":"SortAdornment_icon__7nC5Q","up":"SortAdornment_up__3s03s","down":"SortAdornment_down__1DZQ6","active":"SortAdornment_active__2Bz3A"};